module.exports = __webpack_public_path__ + "res/27-img_card_bg_even.5966d9d0295bcfc0309403052104ab7b.png";